import BecomeAPartner from "pages/BecomeAPartner";

export const HelperConstant = {
  // imageAPI: "http://dofycdn.inventsoftlabs.in/",
  // CDNimageAPI: "https://dofycdn.inventsoftlabs.in/v2/",
  // productionCDNUrl:"https://cdn.dofy.in/v2/",
  // imageAPI: schema + "//cdn.dofy.in",
  osTypeId: { ANDROID: 2, IOS: 3 },
  serviceTypeId: { REPAIR: 3, SELL: 2 },
  defaultAPIKey: "BaseSecurityAPIkey 2cf24dba5fb0a30e26e83b2ac5b9e29e1b161e5c1fa6525e83042262948b9824",
  Roles: { Admin: 1, Super_Admin: 2, Rider: 3, Public: 4, Configurator: 5, SEO: 6, Operational_Manager: 7, Tele_Caller: 8, Vendor: 9 },
  emailPattern: { pattern: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/, },
  phonenumberPattern: { pattern: /^[6-9]\d{9}$/ },
  UAEPhonenumberPattern: { pattern: /^(?:[0-9]\d{8}|\d{10})$/ },
  productTypeId: { phone: 0 },
  ProductTypeName: { Phone: "Phone", Laptop: "Laptop", Tablet: "Tablet", Gaming_Console: "Gaming Console", Desktop: "Desktop", TV: "TV", Smartwatch: "Smartwatch", Camera: "Camera", Earbud: "Earbud", Smart_Speaker: "Smart Speaker" },
  documentTypeId: {
    PanCard: 1,
    Aadhar_Card: 2,
    Driving_License: 3,
    Selfie: 4,
    Id_Front: 5,
    Id_Back: 6,
    Bill: 7,
    Warranty: 8,
    Signature: 9,
    Front: 10,
    Back: 11,
    Top: 12,
    Bottom: 13,
    Left: 14,
    Right: 15,
  },
  dashboardNameIndex: {
    AllOrders: 1,
    OpenOrders: 2,
    InProgressOrders: 3,
    CompletedOrders: 4,
    FailedOrders: 5,
    CancelRequestOrders: 6,
    CancelledOrders: 7,
    PendingOrders: 8,
    ReturnOrders: 9,
    searchData: null,
  },
  orderStatus: {
    PendingOrders: "Pending",
    PublicRecalculation: "Public-Recalculation",
  },

  QuestionnaireTypeId: {
    Screen: 4,
    Body: 5,
    Functional: 2,
    Warranty: 6,
    Accessories: 3,
  },
  otpVerificationTime: { timer: 120 },
  StatusId: {
    All: null,
    PENDING: 1,
    SCHEDULED: 2,
    INPROGRESS: 3,
    ASSIGNED: 4,
    CANCELLED: 5,
    RESCHEDULED: 6,
    FAILED: 7,
    REQUOTE: 8,
    COMPLETED: 9,
    DELAYED: 10,
    CANCEL_REQUEST: 14,
    MODIFIED_PRICE: 19,
    PUBLICRECALCULATION: 25,
    RETURN: 26,
    // SCHEDULED_BY_TELECALLER: 30,
    ADMINCRECALCULATION: 30,

  },
  questionnaireType: {
    DeviceDetails: 1,
    FunctionalDetails: 2,
    PossessionDetails: 3,
    DeviceScreenDetails: 4,
    DeviceBodyDetails: 5,
    DeviceAge: 6,
    BillingSection: 7,
    GameCDs: 8,
    PhysicalCondition: 9,
    ScreenCondition: 10,
    SystemConfiguration: 11,
    AdditionalFeatures: 12,
    AdditionalLens: 13,
  },
  RatingTooltip: ["Terrible", "Bad", "Average", "Great", "Excellent"],
  UserRoleName: { Public: "Public" },
  FeedbackStatus: {
    Open: 1,
    InProgress: 2,
    Completed: 3
  },

  Request_For_Pickup_StatusIds: {
    Open: 22,
    InProgress: 23,
    Completed: 24
  },
  
  Request_For_Pickup_StatusEnums: {
    Open: "Open",
    InProgress: "InProgress",
    Completed: "Completed"
  },
  Request_For_Blog_StatusEnums: {
    All :"All",
    Draft: "Draft",
    Publish: "Publish",
    UnPublish: "UnPublish"
  },

  Corporate_Trade_In_StatusIds: {
    Open: 1,
    InProgress: 2,
    Completed: 3
  },

  Corporate_Trade_In_StatusEnums: {
    Open: "Open",
    InProgress: "In Progress",
    Completed: "Completed"
  },

  Became_a_Partner_StatusEnums: {
    Open: "Open",
    Approved: "Approved",
    Rejected: "Rejected"
  },

  Write_To_Us_StatusEnums: {
    Open: "Open",
    InProgress: "InProgress",
    Completed: "Completed"
  },
  
  Write_To_Us_StatusIds: {
    Open: 1,
    InProgress: 2,
    Completed: 3
  },
  EntityTypeId: {
    ORDERS: 1,
    PAYMENT: 2,
    CANCELLATION: 3,
    FAILED_ORDERS: 4,
    TESTIMONIAL: 5,
    YOUTUBE: 6,
    HOTSELLING: 7,
    BLOGS: 8,
    RESCHEDULED: 9,
    PRODUCT_VALUE: 10,
    THRESHOLD_VALUE: 11,
    ORDER_DOCUMENTS: 12,
    DEVICE_PICTURES: 13,
    SMS: 14,
    EMAIL: 15,
    NEW_ITEM: 16,
    LOCATION_REQUEST: 17,
    BECOME_A_PARTNER: 18,
  },
  BecameAPartnerStatusId: {
    Open: 27,
    Approved: 28,
    Rejected: 29
  }

};
